module.exports = __webpack_public_path__ + "img/20191120162237360截图20191120161321071.4f03bc2a.jpg";